import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  BusinessTripItem,
  BusinessTripPlan,
  BusinessTripRelationPage,
  CrmRelationObjectType,
} from './types/business-trip';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/business-trip/relations';

export interface QueryBusinessTripRelationsParams {
  objectType: CrmRelationObjectType;
  objectUuid: string;
  page?: number;
  pageSize?: number;
}

const normalizePage = <T>(response: unknown): BusinessTripRelationPage<T> => {
  if (!response || typeof response !== 'object') {
    throw new Error('出差助手返回结构异常');
  }
  const value = response as Record<string, unknown>;
  if (!Array.isArray(value.data)) {
    throw new Error('出差助手返回结构异常');
  }

  return {
    data: value.data as T[],
    total: Number(value.total) || 0,
    page: Number(value.page) || 1,
    pageSize: Number(value.pageSize) || value.data.length || 20,
  };
};

const queryRelations = async <T>(
  path: string,
  params: QueryBusinessTripRelationsParams,
  options?: ApiRequestOptions,
) => {
  const response = await request<unknown>(`${BASE_PATH}/${path}`, {
    method: 'GET',
    params: {
      page: 1,
      pageSize: 20,
      ...params,
    },
    ...(options || {}),
  });
  return normalizePage<T>(response);
};

export const queryBusinessTripItems = (
  params: QueryBusinessTripRelationsParams,
  options?: ApiRequestOptions,
) => queryRelations<BusinessTripItem>('items', params, options);

export const queryBusinessTripPlans = (
  params: QueryBusinessTripRelationsParams,
  options?: ApiRequestOptions,
) => queryRelations<BusinessTripPlan>('plans', params, options);

export type TripKind = 'items' | 'plans';
export const tripRequest = <T>(path: string, method: 'GET' | 'POST' | 'PATCH' | 'DELETE' = 'GET', data?: unknown, params?: Record<string, unknown>) =>
  request<T>(`/bff/zy-crm/business-trip/${path}`, { method, data, params, skipErrorHandler: true });
export const tripRows = <T>(value: T[] | { data: T[] }): T[] => {
  if (Array.isArray(value)) return value;
  if (value && Array.isArray(value.data)) return value.data;
  throw new Error('出差助手返回结构异常');
};
